import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import type { UserDetail } from 'types/api'

import { clientsQueryKey } from '../queries/useClients'

export function useSetLandlordInactive() {
  const toast = useToast()
  const queryClient = useQueryClient()
  const onError = useOnError()
  const { t } = useTranslation('users')

  async function setLandlordInactive({
    id,
    inactive
  }: {
    id: string
    inactive: boolean
  }) {
    const res = await apiClient.patch<UserDetail>(`${SNA_PREFIX}users/${id}`, {
      landlord_inactive: inactive
    })
    return res.data
  }

  return useMutation({
    mutationFn: setLandlordInactive,
    onSuccess: (_, { inactive }) => {
      toast.success({
        message: t(
          inactive ? 'landlordStatus.toastOn' : 'landlordStatus.toastOff'
        )
      })
      // Covers both the landlord list and the detail (['clients', id]).
      queryClient.invalidateQueries({ queryKey: clientsQueryKey })
    },
    onError
  })
}
